/* eslint-disable no-shadow */
/* eslint-disable no-console */

import ToolsAPI from '../../api/tools';
import KnowledgesAPI from '../../api/knowledges';
import types from '../mutation-types';

const demodata = [
  {
    id: 1,
    name: 'Authentication',
    description: 'User login and registration module',
    toolType: 'web',
  },
  {
    id: 2,
    name: 'Dashboard',
    description: 'Admin analytics dashboard',
    toolType: 'web',
  },
  {
    id: 3,
    name: 'Payment Gateway',
    description: 'Stripe-based subscription handling',
    toolType: 'web',
  },
  {
    id: 4,
    name: 'Notification Service',
    description: 'Email and push notifications',
    toolType: 'client',
  },
  {
    id: 5,
    name: 'File Upload',
    description: 'Upload and manage user files',
    toolType: 'web',
  },
  {
    id: 6,
    name: 'Profile Manager',
    description: 'User profile settings and preferences',
    toolType: 'client',
  },
  {
    id: 7,
    name: 'Search Engine',
    description: 'Full-text search with filters',
    toolType: 'web',
  },
  {
    id: 8,
    name: 'Chat Module',
    description: 'Real-time messaging system',
    toolType: 'client',
  },
  {
    id: 9,
    name: 'Report Generator',
    description: 'Generate PDF and CSV reports',
    toolType: 'web',
  },
  {
    id: 10,
    name: 'Settings',
    description: 'Application configuration options',
    toolType: 'client',
  },
];

export const state = {
  tools: [],
  meta: {
    count: 0,
    current_page: 1,
    page_size: 25,
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,

    isKnowledgeFetching: false,
    isKnowledgeCreating: false,
    isKnowledgeDeleting: false,
    isKnowledgeUpdating: false,
  },

  // knowledgebased
  knowledges: [],
  meta_knowledge: {
    count: 0,
    current_page: 1,
    page_size: 25,
  },
};

// list of getters
const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getTools(_state) {
    return _state.tools;
  },

  getMetaKnowledge(_state) {
    return _state.meta_knowledge;
  },
  getKnowledges(_state) {
    return _state.knowledges;
  },
};

// actions list
const actions = {
  fetchTools: async ({ commit, state }, query) => {
    commit(types.SET_TOOLS_UI_FLAG, { isFetching: true });
    try {
      // commit(types.SET_TOOLS, demodata);
      const response = await ToolsAPI.getToolList(query);
      const newData = response.data?.data || [];
      const meta = {
        ...state.meta,
        ...(response.data?.meta || {}),
      };
      // if page = 1, make empty the list
      if (query.page === 1) {
        commit(types.SET_TOOLS, newData);
      } else {
        // Append to existing list
        const combined = [...state.tools, ...newData];
        commit(types.SET_TOOLS, combined);
      }
      // Save pagination metadata
      commit(types.SET_TOOLS_META, meta);

      commit(types.SET_TOOLS_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.error('Error filtering tools:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isFetching: false });
    }
  },
  filterTools: async ({ commit, state }, query) => {
    commit(types.SET_TOOLS_UI_FLAG, { isFetching: true });
    try {
      // commit(types.SET_TOOLS, demodata);
      const response = await ToolsAPI.getToolsFilterList(query);
      const newData = response.data?.data || [];
      const meta = {
        ...state.meta,
        ...(response.data?.meta || {}),
      };
      // if page = 1, make empty the list
      if (query.page === 1) {
        commit(types.SET_TOOLS, newData);
      } else {
        // Append to existing list
        const combined = [...state.tools, ...newData];
        commit(types.SET_TOOLS, combined);
      }
      // Save pagination metadata
      commit(types.SET_TOOLS_META, meta);

      commit(types.SET_TOOLS_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.error('Error filtering tools:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isFetching: false });
    }
  },

  createTool: async ({ commit, state }, payload) => {
    commit(types.SET_TOOLS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ToolsAPI.createTool(payload);
      commit(types.SET_TOOLS_CREATE, data);
      commit(types.SET_TOOLS_UI_FLAG, { isCreating: false });
      return data;
    } catch (error) {
      console.error('Error creating tool:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isCreating: false });
      throw error;
    }
  },
  updateToolById: async ({ commit, state }, { tool_id, payload }) => {
    commit(types.SET_TOOLS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await ToolsAPI.updateToolById(tool_id, payload);
      commit(types.SET_TOOLS_UPDATE, data);
      commit(types.SET_TOOLS_UI_FLAG, { isUpdating: false });
      return data;
    } catch (error) {
      console.error('Error updating tool:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isUpdating: false });
      throw error;
    }
  },
  deleteToolById: async ({ commit, state }, { tool_id }) => {
    commit(types.SET_TOOLS_UI_FLAG, { isDeleting: true });
    try {
      const { data } = await ToolsAPI.deleteToolById(tool_id);
      commit(types.SET_TOOLS_DELETE, tool_id);
      commit(types.SET_TOOLS_UI_FLAG, { isDeleting: false });
      return data;
    } catch (error) {
      console.error('Error deleting tool:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isDeleting: false });
      throw error;
    }
  },

  // knowledges CRUD
  fetchKnowledges: async ({ commit, state }, query) => {
    commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeFetching: true });
    try {
      const response = await KnowledgesAPI.getKnowledgeList(query);
      const newData = response.data?.data || [];
      const meta = {
        ...state.meta_knowledge,
        ...(response.data?.meta || {}),
      };

      commit(types.SET_KNOWLEDGE, newData);
      commit(types.SET_KNOWLEDGE_META, meta);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeFetching: false });
    } catch (error) {
      console.error('Error filtering knowledge:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeFetching: false });
    }
  },
  filterKnowledges: async ({ commit, state }, query) => {
    commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeFetching: true });
    try {
      const response = await KnowledgesAPI.getKnowledgesFilterList(query);
      const newData = response.data?.data || [];
      const meta = {
        ...state.meta_knowledge,
        ...(response.data?.meta || {}),
      };
      commit(types.SET_KNOWLEDGE, newData);
      commit(types.SET_KNOWLEDGE_META, meta);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeFetching: false });
    } catch (error) {
      console.error('Error filtering knowledge:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeFetching: false });
    }
  },
  createKnowledge: async ({ commit }, payload) => {
    commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeCreating: true });
    try {
      const { data } = await KnowledgesAPI.createKnowledge(payload);
      commit(types.SET_KNOWLEDGE_CREATE, data);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeCreating: false });
      return data;
    } catch (error) {
      console.error('Error filtering tools:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeCreating: false });
      throw error;
    }
  },
  updateKnowledgeById: async ({ commit }, { knowledge_id, payload }) => {
    commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeUpdating: true });
    try {
      const { data } = await KnowledgesAPI.updateKnowledgeById(
        knowledge_id,
        payload
      );
      commit(types.SET_KNOWLEDGE_UPDATE, data);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeUpdating: false });
      return data;
    } catch (error) {
      console.error('Error updating knowledge:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeUpdating: false });
      throw error;
    }
  },
  deleteKnowledgeById: async ({ commit }, { knowledge_id }) => {
    commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeDeleting: true });
    try {
      const { data } = await KnowledgesAPI.deleteKnowledgeById(knowledge_id);
      commit(types.SET_KNOWLEDGE_DELETE, knowledge_id);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeDeleting: false });
      return data;
    } catch (error) {
      console.error('Error deleting knowledge:', error);
      commit(types.SET_TOOLS_UI_FLAG, { isKnowledgeDeleting: false });
      throw error;
    }
  },
};

// list of mutations
const mutations = {
  // mutate UI flags
  [types.SET_TOOLS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_TOOLS]($state, data) {
    $state.tools = data;
  },
  [types.SET_TOOLS_META]($state, meta) {
    $state.meta = {
      ...meta,
      count: meta.count || 0,
      current_page: meta.current_page || 1,
      page_size: meta.page_size || 15,
    };
  },

  [types.SET_TOOLS_CREATE]($state, data) {
    $state.tools.unshift(data);
  },

  [types.SET_TOOLS_UPDATE]($state, data) {
    const index = $state.tools.findIndex(el => el.id === data.id);
    if (index !== -1) {
      // Replace existing coupon
      $state.tools.splice(index, 1, data);
    } else {
      // If not found, add the new coupon
      $state.tools.push(data);
    }
  },
  [types.SET_TOOLS_DELETE]($state, tool_id) {
    const index = $state.tools.findIndex(el => el.id === tool_id);
    if (index !== -1) {
      $state.tools.splice(index, 1);
    }
  },

  // knowldege CRUD
  [types.SET_KNOWLEDGE]($state, data) {
    $state.knowledges = data;
  },
  [types.SET_KNOWLEDGE_META]($state, meta) {
    $state.meta_knowledge = {
      ...meta,
      count: meta.count || 0,
      current_page: meta.current_page || 1,
      page_size: meta.page_size || 15,
    };
  },

  [types.SET_KNOWLEDGE_CREATE]($state, data) {
    $state.knowledges.unshift(data);
  },

  [types.SET_KNOWLEDGE_UPDATE]($state, data) {
    const index = $state.knowledges.findIndex(el => el.id === data.id);
    if (index !== -1) {
      // Replace existing coupon
      $state.knowledges.splice(index, 1, data);
    } else {
      // If not found, add the new coupon
      $state.knowledges.push(data);
    }
  },
  [types.SET_KNOWLEDGE_DELETE]($state, knowledge_id) {
    const index = $state.knowledges.findIndex(el => el.id === knowledge_id);
    if (index !== -1) {
      $state.knowledges.splice(index, 1);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
